import { Dic } from "@src/common/utils";
import utils from "@src/common/utils";
const tableOption = function (that) {
  return {
    page: true,
    selection: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: " ：",
    labelWidth: "70px",
    dialogWidth: "700px",
    viewDialogWidth: "700",
    emptyText: "暂无数据",
    column: [
      {
        label: "名称",
        prop: "handleProcessName",
        search: true,
      },
      {
        label: "描述",
        prop: "desc",
      },
      {
        label: "创建人",
        prop: "creator",
      },
      {
        label: "创建时间",
        prop: "createTime",
      },
      {
        label: "修改人",
        prop: "modifier",
      },
      {
        label: "修改时间",
        prop: "modifyTime",
      },
    ]
  };
};
export default tableOption;
